import React from "react";
import "./stylesLocationRestrictionsTableRow.css";

import SortIcon from "../../../assets/icons/ic_sort.svg";
import { formatNumber } from "chart.js/helpers";
import NewDropdown from "../../CommonComponents/NewDropdown/NewDropdown";
import ToggleSwitch from "../../CommonComponents/ToggleSwitch/ToggleSwitch";

function LocationRestrictionsTableRow({ is_header_row, data, handleSort }) {
  if (data?.last_evaluated_key) return null;

  const options = [
    { value: 0, label: "Coins only" },
    { value: 1, label: "Cash only" },
    { value: 2, label: "Cash & Coins" },
  ];

  return (
    <div
      className={`table-row ${
        is_header_row
          ? "table-header-row"
          : data.activity
          ? "active"
          : "inactive"
      }`}
    >
      <div className="cell-small extra-small">
        <p className="cell-label">{is_header_row ? "ID" : data?.id}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("id")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">{is_header_row ? "State" : data?.state}</p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("state")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">
          {is_header_row ? "Note according to the update" : data?.note}
        </p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("note")}
          />
        )}
      </div>
      <div className="cell-small">
        <p className="cell-label">
          {is_header_row
            ? "Redemption restrictions"
            : `$${formatNumber(data?.restrictions)}`}
        </p>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("restrictions")}
          />
        )}
      </div>
      <div className="cell-small">
        <div className="cell-label overflow-visible">
          {is_header_row ? (
            "Ability"
          ) : (
            <NewDropdown
              options={options}
              selectedValue={data?.ability}
              onChange={(value) => {}}
            />
          )}
        </div>
        {is_header_row && (
          <img
            src={SortIcon}
            alt="sort icon"
            onClick={() => handleSort("ability")}
          />
        )}
      </div>

      <div className="cell-small">
        <p className="cell-label overflow-visible">
          {is_header_row ? (
            "Activity"
          ) : (
            <ToggleSwitch
              status={data.activity}
              eventCode={1}
              updateEventCode={() => {}}
            />
          )}
        </p>
      </div>
    </div>
  );
}

export default LocationRestrictionsTableRow;
